import { render, staticRenderFns } from "./AccountSmsMessages.vue?vue&type=template&id=779febf2&"
import script from "./AccountSmsMessages.vue?vue&type=script&lang=js&"
export * from "./AccountSmsMessages.vue?vue&type=script&lang=js&"
import style0 from "./AccountSmsMessages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports